var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhtsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.9374L4.57558 48.2634C1.74884 43.3719 0.264051 37.8232 0.270879 32.1764C0.278331 14.4341 14.7445 0 32.5213 0C41.1478 0.00437477 49.2448 3.35501 55.3343 9.43726C61.4239 15.5195 64.7744 23.6041 64.7713 32.2023C64.7634 49.9433 50.295 64.38 32.5209 64.38H32.5068C27.1098 64.3778 21.8067 63.0265 17.0961 60.4628L0 64.9374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 5.43538C17.7445 5.43538 5.72013 17.4323 5.71487 32.1784C5.70759 37.2137 7.12828 42.1483 9.81269 46.4117L10.4504 47.4236L7.74208 57.2922L17.8873 54.6371L18.867 55.2164C22.9815 57.6535 27.6991 58.9423 32.51 58.945H32.5201C47.2944 58.945 59.3187 46.9467 59.3244 32.1998C59.3356 28.6849 58.6481 25.2028 57.3017 21.9549C55.9553 18.707 53.9768 15.758 51.4808 13.2785C48.9986 10.7854 46.0455 8.80852 42.7926 7.46225C39.5398 6.11598 36.0516 5.42706 32.5302 5.43538Z",
    fill: "url(#paint0_linear_2147_1173)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4599 18.7242C23.8559 17.385 23.2204 17.3579 22.6466 17.3347L21.102 17.3159C20.5646 17.3159 19.6915 17.5172 18.9534 18.3221C18.2153 19.1271 16.1328 21.0725 16.1328 25.0295C16.1328 28.9865 19.0204 32.81 19.4228 33.3473C19.8252 33.8845 24.9973 42.2635 33.1881 45.4873C39.9947 48.1664 41.3798 47.6335 42.8578 47.4997C44.3358 47.3658 47.6254 45.5542 48.2965 43.6761C48.9675 41.798 48.968 40.189 48.7668 39.8526C48.5656 39.5161 48.0282 39.3162 47.2217 38.9137C46.4152 38.5113 42.4541 36.5658 41.7156 36.2972C40.977 36.0286 40.4401 35.8951 39.9023 36.7001C39.3644 37.5051 37.822 39.3158 37.3517 39.8526C36.8814 40.3893 36.4119 40.4567 35.6054 40.0547C34.7989 39.6526 32.2041 38.803 29.1254 36.0631C26.73 33.9313 25.113 31.2986 24.6423 30.494C24.1715 29.6895 24.5923 29.2538 24.9964 28.8531C25.3581 28.4926 25.8021 27.9138 26.2058 27.4444C26.6094 26.975 26.7423 26.6394 27.0105 26.1035C27.2788 25.5676 27.1451 25.0969 26.9434 24.6948C26.7418 24.2928 25.1762 20.3148 24.4599 18.7242Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2147_1173",
    x1: 31.974,
    y1: 8.64646,
    x2: 32.2447,
    y2: 54.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhtsappIcon);
export default __webpack_public_path__ + "static/media/whtsappIcon.ec784e9557dfe336319356adb2e888ba.svg";
export { ForwardRef as ReactComponent };